/**
 * GuestPortalFooter - Dynamic legal footer for guest portals
 * Shows branded "Powered by" footer with configurable brand name
 */
import { Link } from "react-router-dom";

export default function GuestPortalFooter({ 
  poweredByBrand = "my_concierge_portal",
}) {
  const currentYear = new Date().getFullYear();
  const isMyWorldVIP = poweredByBrand === "my_world_vip";
  const brandName = isMyWorldVIP ? "My World VIP" : "My Concierge Portal";
  const copyrightText = isMyWorldVIP 
    ? `\u00A9 ${currentYear} My World VIP Ltd. All rights reserved.`
    : `\u00A9 ${currentYear} My Concierge Portal. All rights reserved.`;

  return (
    <footer className="w-full py-8 px-4 border-t border-border/30 bg-background/50 mt-auto">
      <div className="max-w-4xl mx-auto text-center space-y-3">
        <p className="text-sm text-muted-foreground/80 tracking-wide">
          Powered by{" "}
          {isMyWorldVIP ? (
            <a
              href="https://myworldvip.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground/70 hover:text-foreground transition-colors"
            >
              {brandName}
            </a>
          ) : (
            <span className="font-medium text-foreground/70">{brandName}</span>
          )}
        </p>
        {isMyWorldVIP && (
          <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground/60">
            <Link to="/terms" className="hover:text-foreground/70 transition-colors">Terms &amp; Conditions</Link>
            <span className="text-border">|</span>
            <Link to="/privacy" className="hover:text-foreground/70 transition-colors">Privacy Policy</Link>
          </div>
        )}
        <p className="text-xs text-muted-foreground/60">
          {copyrightText}
        </p>
      </div>
    </footer>
  );
}
